export class ProductUpdate {
	id: string;

	packageSizeForCalculation: number | null;

	constructor(id: string, packageSizeForCalculation: number | null) {
		this.id = id;
		this.packageSizeForCalculation = packageSizeForCalculation;
	}
}
